import type { ComponentProps } from 'react'

import { GLYPH_ANCHOR_BOX } from '@/components/practice/glyph-anchor'
import { cn } from '@/lib/utils'

/**
 * Renders a loading placeholder with the exact em-box of `GlyphAnchor`,
 * for skeletons of surfaces that open on the glyph anchor.
 */
export function GlyphAnchorSkeleton({
    className,
    ...props
}: ComponentProps<'div'>) {
    return (
        <div
            className={cn(
                GLYPH_ANCHOR_BOX,
                'animate-pulse rounded-sm bg-surface-sunken',
                className
            )}
            {...props}
        />
    )
}
